import { Component } from '@angular/core';
import { IMAGE_LIST } from '@app-core/constants/constants';

@Component({
  selector: 'app-driver-enrollment',
  templateUrl: './driver-enrollment.component.html',
  styleUrls: ['./driver-enrollment.component.scss'],
})
export class DriverEnrollmentComponent {
  public imageList: { imageUrl: string; isValid: boolean }[] = IMAGE_LIST;

  constructor() {}
}
